/* unplugin-vue-components disabled */import { render } from "./picture_compare.vue?vue&type=template&id=348437dd"
import script from "./picture_compare.vue?vue&type=script&lang=js"
export * from "./picture_compare.vue?vue&type=script&lang=js"

import "./picture_compare.vue?vue&type=style&index=0&id=348437dd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__